const state = {
    cityLocation: {}
}

const mutations = {
    'SET_CITY_LOCATION' (state, cityLocation) {
        state.cityLocation = cityLocation
    },
}

const getters = {
    cityLocation: state => state.cityLocation
}

export default {
    state,
    mutations,
    getters
}
